import React, { useState } from "react";
import ReactGA from "react-ga";
import KioskLayout from "components/Layout/KioskLayout";
import FacilitiesList from "components/Kiosk/Facilities/FacilitiesList";
import FacilitiesBanner from "components/Kiosk/Facilities/FacilitiesBanner";
import FilterSection from "components/shared/FilterSection";
import useFetch from "hooks/useFetch";
import { mainApiPath } from "api/constants";
import useGetFloorLvl from "hooks/useGetFloorLvl";
import { useSelector,useDispatch } from "react-redux";
import useGaPageView from "hooks/useGaPageView";
import { facility, facilityName, facilityIcon } from "config/facilities";
import MapRouterMaster from "containers/MapRouterMaster";
import { mapRouterType, screenKeys, gaSettings } from "config/constants";
import playClickSpecial from "utils/playClickSpecial";

const KioskFacilities = () => {
  const dispatch = useDispatch()
  const [error, loading, data] = useFetch(mainApiPath.facilities);
  const langState = useSelector((state) => state.language.lang);
  const floorLevel = useGetFloorLvl();
  const [facilitySelect, setFacilitySelect] = useState(null);

  const gaTitle = gaSettings.facilities.title;
  const gaLocation = gaSettings.facilities.location;
  useGaPageView({ gaTitle, gaLocation });

  const facilities = Object.keys(facility).map((f) => {
    return {
      type: facility[f],
      title: facilityName[f][langState],
      icon: facilityIcon[f],
    };
  });

  const hanleFacilitySelect = (event, f) => {
    event.preventDefault();
    playClickSpecial();
    setFacilitySelect(f);
    ReactGA.pageview(
      gaSettings.facilitiesDetail.location + facilityName[f][langState],
      null,
      gaSettings.facilitiesDetail.title,
    );
    dispatch({ type: 'FILTER_BY_NAME', payload: '' });
  };

  return (
    <KioskLayout
      error={error}
      loading={loading}
      goBack={screenKeys.kiosk}
      left={
        <>
          <MapRouterMaster
            type={mapRouterType.overview}
            floorIndex={floorLevel}
            locationsHighlighted={facilitySelect}
            layout={"kiosk"}
          />
          <FilterSection
            floors={data ? data.floors : null}
            floorfilter
            loading={loading}
          />
          <FacilitiesBanner
            banner={data ? data.banner : null}
            loading={loading}
          />
        </>
      }
      right={
        <FacilitiesList
          facilities={facilities}
          loading={loading}
          click={hanleFacilitySelect}
          select={facilitySelect}
        />
      }
    />
  );
};

export default KioskFacilities;
